// Utility helpers for credit / leasing tables

// Parse DD.MM.YYYY -> sortable tuple
function parseDate(s) {
  if (!s || typeof s !== "string") return null;
  const [d, m, y] = s.split(".");
  if (!d || !m || !y) return null;
  return new Date(Number(y), Number(m) - 1, Number(d));
}

/**
 * Returns end-date, paid count, total count, remaining count for a payments[] array.
 * "End date" = date of the LAST unpaid payment (or last payment if all paid).
 */
export function getObligationStats(payments) {
  const list = Array.isArray(payments) ? payments : [];
  const total = list.length;
  const paid = list.filter((p) => p?.paid).length;
  const remaining = total - paid;

  // Sort chronologically and pick the relevant "end" date
  const withDate = list
    .map((p) => ({ ...p, _d: parseDate(p?.date) }))
    .filter((p) => p._d)
    .sort((a, b) => a._d - b._d);

  // End date = last unpaid installment date (or last payment date if all paid)
  const lastUnpaid = [...withDate].reverse().find((p) => !p.paid);
  const endDate = lastUnpaid
    ? lastUnpaid.date
    : withDate.length > 0
      ? withDate[withDate.length - 1].date
      : null;

  return { total, paid, remaining, endDate };
}

/**
 * Returns the nearest UNPAID payment (earliest date among unpaid).
 * { amount, date, payment_number } or null if all paid.
 */
export function getNextUnpaidPayment(payments) {
  const list = Array.isArray(payments) ? payments : [];
  const unpaid = list
    .filter((p) => !p?.paid)
    .map((p) => ({ ...p, _d: parseDate(p?.date) }))
    .filter((p) => p._d)
    .sort((a, b) => a._d - b._d);
  if (!unpaid.length) return null;
  const p = unpaid[0];
  return {
    amount: Number(p.amount) || 0,
    date: p.date,
    payment_number: p.payment_number,
  };
}

/** Sum of all UNPAID payment amounts. */
export function getTotalUnpaidAmount(payments) {
  const list = Array.isArray(payments) ? payments : [];
  return list
    .filter((p) => !p?.paid)
    .reduce((s, p) => s + (Number(p?.amount) || 0), 0);
}

export function formatEndDate(d) {
  return d || "—";
}

export function fmtPLN(v) {
  return (
    (Number(v) || 0).toLocaleString("pl-PL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + " zł"
  );
}
